/// <reference path="../typings/index.d.ts" />
namespace App.Modulos {
  export class Conta {
    public static inicializar() {
      var conta = new App.Conta();
      conta.inicializarEventos();
    }
  }
}

namespace App {
  export class Conta {
    private ajax: IAjax;

    private elementoLinkAtivarDesativarRenovacaoAutomatica: JQuery = $("#renovacaoAutomatica");
    private elFormDadosPessoais: JQuery = $("#formularioDados");
    private elFormAlterarSenha: JQuery = $("#formularioAlterarSenha");
    private elLinkRemoverConta: JQuery = $(".remover-conta");
    private elBtnDesconectarTelegram: JQuery = $(".btn-desconectar-telegram");
    private elBtnLimparRegAntigos: JQuery = $("#limparRegAntigos");

    // ### Acoes datatable contas vinculadas ############################
    private objSelect2: ISelect2 = null;
    private elBtnSelecionarTodosOsFiltros: JQuery = $(".btn-selecionar-todos-os-filtros");
    private elBtnApagarTodosOsFiltros: JQuery = $(".btn-apagar-todos-os-filtros");
    private elTabelaContasvinculadas: JQuery = $("#dataTableContasVinculadas")
    private elBtnAplicarProfile: JQuery = $(".btn-aplicar-profile");
    private elBtnAplicarFiltros: JQuery = $(".btn-aplicar-filtros");
    private urlAplicarPerfil: string = null;
    private urlAplicarFiltro: string = null;
    private urlAtivarContas: string = null;
    // ##########################################################################


    private modelViewContasVinculadas: any = null;
    // Índice id_conta_ea -> objeto de dados entregue ao DataTables, para atualizar linhas
    // que ainda não foram renderizadas (a tabela só monta o HTML da página visível).
    private dadosContasPorId: any = {};


    public inicializarEventos() {
      this.inicializarAtivarDesativarRenovacaoAutomatica();
      this.elBtnDesconectarTelegram.on("click", (e) => { this.desconectarTelegram(e) });
      this.elBtnLimparRegAntigos.on('click', (e) => { this.aoLimparRegistrosAntigos(e); });

      // ### Acoes datatable contas vinculadas ############################
      this.objSelect2 = new Select2();
      this.objSelect2.inicializarCampo($('.select2'));
      this.objSelect2.inicializarCampo($('.select-tag'), Util.getOptionsSelectTag());
      this.elBtnSelecionarTodosOsFiltros.on("click", (e) => { this.aoSelecionarTodosOsFiltros(e) });
      this.elBtnApagarTodosOsFiltros.on("click", (e) => { this.aoApagarTodosOsFiltros(e) });
      this.elBtnAplicarProfile.on("click", (e) => { this.aoAplicarPerfil(e) });
      this.elBtnAplicarFiltros.on("click", (e) => { this.aoAplicarFiltros(e) });
      // ##########################################################################
      this.inicializarCrudContasVinculadas();
      $(document).on('click', '.remover-conta', (e) => { this.aoExcluirRegistro(e) });
      $(document).on('change', '.js-toggle-ativar-conta', (e) => { this.aoAtivarContaLinha(e) });
    }

    private inicializarAtivarDesativarRenovacaoAutomatica() {
      this.elementoLinkAtivarDesativarRenovacaoAutomatica.on('click', (e) => { this.aoDesativarRenovacaoAutomatica(e) });
      this.elFormDadosPessoais.on('submit', (e) => { this.aoSubmeterFormulario(e) });
      this.elFormAlterarSenha.on('submit', (e) => { this.aoSubmeterFormulario(e) });
    }

    private aoDesativarRenovacaoAutomatica(e: JQueryEventObject) {
      var elemento = $(e.target);
      if (elemento.data('renovacao_automatica') === 1) {
        this.ativarDesativarRenovacaoAutomatica(e)
      } else {
        App.Util.exebirSweetConfirmacao(e, "Você tem certeza disso?", "Se cancelado, ao final da sua assinatura não ocorrerá mais a renovação automática.", "Sim, continuar", this.ativarDesativarRenovacaoAutomatica);
      }
    }

    private aoSubmeterFormulario(e: JQueryEventObject) {
      App.Util.exibirModalPaginaCarregando();
    }

    private ativarDesativarRenovacaoAutomatica(e: JQueryEventObject) {
      this.ajax = new App.Ajax();
      var elemento = $(e.target);
      var dados: any = { renovacao_automatica: elemento.data('renovacao_automatica') };
      this.ajax.postAcao($(e.target).data("url"), dados);
    }

    private aoExcluirRegistro(e: JQueryEventObject) {
      console.log('excluir conta id: ', $(e.currentTarget).data("id"), $(e.currentTarget).data("url"));
      let el = $(e.currentTarget);
      let id = $(e.currentTarget).data("id")
      let url = $(e.currentTarget).data("url")

      var textoExclusao: string = "Essa conta EA será removida/inutilizada, ou seja, <b>não poderá</b> ser utilizada <b>nessa</b> e <b>nem em outra</b> conta FUTSNIPERWEB que <b>não tenha Plano</b> ou que <b>tenha Plano Trial</b> e só poderá ser reativada mediante autorização da nossa equipe.";
      if ($(e.currentTarget).data('vendedor')) {
        textoExclusao = "Sua conta EA será desvínculada da conta FUTSNIPERWEB";
      }

      swal.fire({
        title: "Você tem certeza disso?",
        html: textoExclusao,
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#DD6B55",
        confirmButtonText: "Sim, continuar",
        cancelButtonText: "cancelar",
        closeOnConfirm: true
      }).then((result: any) => {
        if (result.isConfirmed) {
          this.excluirRegistro({ id: id, url: url, el: el });
        }
      });
      return;
    }

    private excluirRegistro(parametros: any) {
      this.ajax = new App.Ajax();
      this.ajax.postAcaoSemCabecalhoGlobal(parametros.url, { id: parametros.id }, (dados: IRespostaSucessoAjx) => {
        this.removerLinhaContaExcluida(dados.parametroCallback);
      }, parametros);
    }

    // A linha precisa sair também dos dados do DataTables, senão volta a aparecer ao paginar/ordenar.
    private removerLinhaContaExcluida(parametros: any) {
      let linha = parametros.el.closest('tr');
      let objDataTable = this.modelViewContasVinculadas ? this.modelViewContasVinculadas.ojDataTableCarregado.objDataTable : null;

      if (objDataTable && linha.closest('#dataTableContasVinculadas').length) {
        objDataTable.row(linha).remove().draw(false);
        return;
      }

      linha.remove();
    }

    public static excluirRegistroNaPagina(dados: IRespostaSucessoAjx) {
      let { id, url, el } = dados.parametroCallback;
      console.log('excluirRegistroNaPagina id: ', id, url, el);
      el.parents("tr").remove();
    }

    private desconectarTelegram(e: JQueryEventObject) {
      Util.exibirModalPaginaCarregando();
      this.ajax = new App.Ajax();
      this.ajax.postAcaoSemCabecalhoGlobal($(e.currentTarget).data("urlDesconectar"), { id: $(e.currentTarget).data("id") }, App.Conta.excluirRegistroNaPagina, e);
    }

    private aoLimparRegistrosAntigos(e: JQueryEventObject) {
      console.log('limpar registros antigos: ');
      let ajax = new Ajax();
      ajax.postAcao('/sniper-detalhes-limpar', {}, (dadosSucesso: IRespostaSucessoAjx) => {
        swal.fire("Pronto!", "Os dados antigos foram removidos com sucesso.", "info");
      });
    }

    private inicializarCrudContasVinculadas() {
      if (!this.elTabelaContasvinculadas.length) {
        return;
      }

      let ehPlanoProOuCloud = this.elTabelaContasvinculadas.data('planoprocloud')
      this.urlAplicarPerfil = this.elTabelaContasvinculadas.data('urlAplicarPerfil')
      this.urlAplicarFiltro = this.elTabelaContasvinculadas.data('urlAplicarFiltro')
      this.urlAtivarContas = this.elTabelaContasvinculadas.data('urlAtivarContas')
      this.modelViewContasVinculadas = new ModelView();
      this.modelViewContasVinculadas.ojDataTableCarregado.elDataTable = this.elTabelaContasvinculadas;
      this.modelViewContasVinculadas.carregardataTable(ehPlanoProOuCloud ?
        [
          {
            className: "btn-sm btn-outline-primary btn-selecionar-tudo",
            text: '<i class="fas fa-check-double font-size-11 m-0"></i> Todos',
            action: () => {
              let itensSelecionados = this.modelViewContasVinculadas.getContasSelecionadas()
              let count = itensSelecionados.count();
              if (count) {
                this.modelViewContasVinculadas.ojDataTableCarregado.objDataTable.rows().deselect();
              } else {
                this.modelViewContasVinculadas.ojDataTableCarregado.objDataTable.rows().select();
              }
            }
          },
          {
            // Seleciona/deseleciona apenas as linhas que passaram no filtro/pesquisa atual.
            className: "btn-sm btn-outline-primary btn-selecionar-filtrados",
            text: '<i class="fas fa-filter font-size-11 m-0"></i> Filtrados',
            action: () => {
              let dt = this.modelViewContasVinculadas.ojDataTableCarregado.objDataTable;
              let filtradas = dt.rows({ search: 'applied' });
              let filtradasSelecionadas = dt.rows({ search: 'applied', selected: true });
              if (filtradasSelecionadas.count() && filtradasSelecionadas.count() === filtradas.count()) {
                filtradas.deselect();
              } else {
                filtradas.select();
              }
            }
          },
          {
            className: "btn-sm btn-outline-primary btn-aplicar",
            text: '+ Perfil',
            action: () => {
              let contasSelecionadas = this.modelViewContasVinculadas.getContasSelecionadas()
              var count = contasSelecionadas.count();
              if (count) {
                $("#modalAplicarPerfil").modal("show")
              }
            }
          },
          {
            className: "btn-sm btn-outline-primary btn-dt-aplicar-filtros",
            text: '+ Filtros',
            action: () => {
              let contasSelecionadas = this.modelViewContasVinculadas.getContasSelecionadas()
              var count = contasSelecionadas.count();
              if (count) {
                $("#modalAplicarFiltros").modal("show")
              }
            }
          },
          {
            className: "btn-sm btn-outline-success btn-ativar-selecionadas",
            text: 'Ativar',
            action: () => { this.aoAtivarContasSelecionadas(true) }
          },
          {
            className: "btn-sm btn-outline-secondary btn-desativar-selecionadas",
            text: 'Desativar',
            action: () => { this.aoAtivarContasSelecionadas(false) }
          }
        ] : [],
        500,
        ehPlanoProOuCloud ? this.obterOpcoesDataTableContasVinculadas() : null
      )

      this.inicializarEventosDataTables()
    }

    /**
     * As linhas da tabela de contas vinculadas chegam como JSON e são renderizadas pelo
     * DataTables (apenas a página visível). Imprimir as linhas no HTML gerava dezenas de MB
     * para quem tem milhares de contas EA.
     */
    private obterOpcoesDataTableContasVinculadas(): any {
      let contas: any[] = [];
      let elDados = $('#dadosContasVinculadas');
      if (elDados.length) {
        try {
          contas = JSON.parse(elDados.text() || '[]');
        } catch (erro) {
          console.error('Falha ao ler os dados das contas vinculadas:', erro);
        }
      }

      this.dadosContasPorId = {};
      contas.forEach((conta: any) => { this.dadosContasPorId[String(conta.id)] = conta; });

      return {
        data: contas,
        columns: this.montarColunasContasVinculadas(),
        createdRow: (linha: any, dados: any) => { $(linha).attr('data-id', dados.id); }
      };
    }

    private montarColunasContasVinculadas(): any[] {
      let exibirIp = !!Number(this.elTabelaContasvinculadas.data('exibirIp'));
      let exibirRemover = !!Number(this.elTabelaContasvinculadas.data('exibirRemover'));
      let urlRemoverConta = this.elTabelaContasvinculadas.data('urlRemoverConta');
      let vendedor = this.elTabelaContasvinculadas.data('vendedor') ? 1 : '';
      let textoAtiva = this.elTabelaContasvinculadas.data('textoAtiva');
      let textoInativa = this.elTabelaContasvinculadas.data('textoInativa');
      let textoRemover = this.elTabelaContasvinculadas.data('textoRemover');

      let esc = (valor: any) => App.Conta.escaparHtml(valor);
      let num = (valor: any) => App.Conta.formatarNumero(valor);
      let badge = (ativo: boolean, textoAtivo: string, textoInativo: string) => ativo
        ? `<span class="badge badge-success text-uppercase cv-badge-on">${textoAtivo}</span>`
        : `<span class="badge badge-danger text-uppercase cv-badge-off">${textoInativo}</span>`;

      let colunas: any[] = [
        {
          data: 'ordem',
          className: 'table-user',
          render: (dado: any, tipo: string) => tipo === 'display' ? `<p class="cv-titulo"><b> ${dado} </b></p>` : dado
        },
        {
          data: 'clube',
          className: 'table-user',
          render: (dado: any, tipo: string, linha: any) => {
            if (tipo === 'sort') { return linha.email; }
            if (tipo !== 'display') { return `${linha.clube} ${linha.plataforma} ${linha.email} #${linha.id}`; }
            return `<p class="cv-titulo"><b><span class="text-uppercase">${esc(linha.clube)}</span> | 🎮${esc(linha.plataforma)}</b></p>`
              + `<p class="cv-subtitulo"><small class="text-muted">${esc(linha.email)}</small></p>`
              + `<p class="cv-rodape"><small class="text-muted">#${esc(linha.id)} | <span>${esc(linha.criadoEm)}</span></small></p>`;
          }
        },
        {
          data: 'nomePerfil',
          render: (dado: any, tipo: string, linha: any) => {
            if (tipo === 'sort') { return linha.idPerfil; }
            if (tipo !== 'display') { return dado || ''; }
            return `<p class="font-size-12 text-limit-quebra-400">${esc(dado)}</p>`;
          }
        },
        {
          data: 'filtros',
          createdCell: (celula: any, dado: any) => { $(celula).attr('title', dado || ''); },
          render: (dado: any, tipo: string) => tipo === 'display'
            ? `<p class="font-size-12 text-limit-quebra-400">${esc(dado)}</p>`
            : (dado || '')
        },
        {
          data: 'agendaAtiva',
          className: 'js-status-tarefa-cell',
          render: (dado: any, tipo: string) => {
            if (tipo === 'display') { return badge(!!dado, 'Habilitada', 'Desabilitada'); }
            if (tipo === 'filter') { return dado ? 'Habilitada' : 'Desabilitada'; }
            return dado ? 1 : 0;
          }
        },
        {
          data: 'ativaSistema',
          render: (dado: any, tipo: string) => {
            if (tipo === 'display') { return badge(!!dado, textoAtiva, textoInativa); }
            if (tipo === 'filter') { return dado ? textoAtiva : textoInativa; }
            return dado ? 1 : 0;
          }
        },
        {
          data: 'redban',
          render: (dado: any, tipo: string) => {
            if (tipo === 'display') {
              return dado
                ? `<span class="badge badge-redban text-uppercase cv-badge-redban">RedBan</span>`
                : `<span class="badge badge-success text-uppercase">Normal</span>`;
            }
            if (tipo === 'filter') { return dado ? 'RedBan' : 'Normal'; }
            return dado ? 0 : 1;
          }
        },
        {
          data: 'mercado',
          render: (dado: any, tipo: string) => {
            if (tipo === 'display') {
              return dado
                ? `<span class="badge badge-success text-uppercase">Com Mercado</span>`
                : `<span class="badge badge-danger badge-sem-mercado text-uppercase">Sem Mercado</span>`;
            }
            if (tipo === 'filter') { return dado ? 'Com Mercado' : 'Sem Mercado'; }
            return dado ? 1 : 0;
          }
        },
        {
          data: 'coins',
          render: (dado: any, tipo: string) => {
            if (tipo === 'display') { return `<span class="text-muted font-weight-bold font-size-14">💰 ${num(dado)}</span>`; }
            return tipo === 'filter' ? num(dado) : dado;
          }
        },
        {
          data: 'requests',
          render: (dado: any, tipo: string) => {
            if (tipo === 'display') { return `<span class="text-muted font-weight-bold font-size-14"> ${num(dado)}</span>`; }
            return tipo === 'filter' ? num(dado) : dado;
          }
        },
        {
          data: 'compras',
          render: (dado: any, tipo: string) => {
            if (tipo === 'display') { return `<span class="text-muted font-weight-bold font-size-14"> ${num(dado)}</span>`; }
            return tipo === 'filter' ? num(dado) : dado;
          }
        },
        {
          data: 'lucro',
          render: (dado: any, tipo: string) => {
            if (tipo === 'display') {
              let classe = dado > 0 ? 'text-success' : (dado < 0 ? 'text-danger' : 'text-muted');
              return `<span class="${classe} font-weight-bold font-size-14"> ${num(dado)}</span>`;
            }
            return tipo === 'filter' ? num(dado) : dado;
          }
        }
      ];

      if (exibirIp) {
        colunas.push({
          data: 'ip',
          render: (dado: any, tipo: string, linha: any) => {
            if (tipo === 'sort') { return linha.nomeServidor ? linha.nomeServidor : linha.ip; }
            if (tipo !== 'display') { return `${linha.nomeServidor || ''} ${linha.ip || ''}`; }
            return `<span>${linha.nomeServidor ? esc(linha.nomeServidor) + '<br>' : ''}${esc(linha.ip)}</span>`;
          }
        });
      }

      colunas.push({
        data: 'atualizadoEm',
        render: (dado: any, tipo: string, linha: any) => {
          if (tipo === 'sort') { return linha.atualizadoOrdem; }
          if (tipo !== 'display') { return dado; }
          return `<span class="text-muted">${esc(dado)}</span>`;
        }
      });

      colunas.push({
        data: null,
        className: 'table-actions',
        orderable: false,
        searchable: false,
        render: (dado: any, tipo: string, linha: any) => {
          if (tipo !== 'display') { return ''; }
          let html = `<label class="custom-toggle custom-toggle-success mr-2 align-middle mb-0" title="Ativar/Desativar conta">`
            + `<input type="checkbox" class="js-toggle-ativar-conta" data-id="${esc(linha.id)}"${linha.agendaAtiva ? ' checked' : ''}>`
            + `<span class="custom-toggle-slider rounded-circle" data-label-off="Desat." data-label-on="Ativa"></span></label>`;

          if (linha.urlServidor) {
            html += `<a href="${esc(linha.urlServidor)}" target="_blank" rel="noopener noreferrer"`
              + ` title="Acessar Dashboard Remoto do seu Servidor"`
              + ` class="btn btn-sm btn-default btn-acessar-servidor mr-1"><i class="fa-solid fa-server"></i></a>`;
          }

          if (exibirRemover) {
            html += `<a href="javascript:void(0)" data-url="${esc(urlRemoverConta)}" data-vendedor="${vendedor}"`
              + ` data-id="${esc(linha.idRegistro)}" class="btn btn-sm btn-outline-warning remover-conta">`
              + `<i class="fa fa-trash"></i> ${esc(textoRemover)}</a>`;
          }

          return html;
        }
      });

      return colunas;
    }

    private static escaparHtml(valor: any): string {
      if (valor === null || valor === undefined) {
        return '';
      }
      return String(valor)
        .replace(/&/g, '&amp;')
        .replace(/</g, '&lt;')
        .replace(/>/g, '&gt;')
        .replace(/"/g, '&quot;')
        .replace(/'/g, '&#039;');
    }

    private static formatarNumero(valor: any): string {
      let numero = Number(valor) || 0;
      let sinal = numero < 0 ? '-' : '';
      return sinal + String(Math.abs(numero)).replace(/\B(?=(\d{3})+(?!\d))/g, '.');
    }

    private async aoAplicarPerfil(e: JQueryEventObject) {
      this.ajax = new App.Ajax();
      let dadosForm: any = this.ajax.convertFormToJSON($("#formAplicarPerfil"));

      // Obter os IDs das contas selecionadas
      const contasIds = this.modelViewContasVinculadas.getIdsContasSelecionadas();
      console.log("IDS", contasIds);

      // Dividir os IDs em lotes de 100
      const lotes = App.Util.chunkArray(contasIds, 100);
      $("#modalAplicarPerfil").modal('hide')

      try {
        // Processar os lotes de forma assíncrona, um por vez
        for (const lote of lotes) {
          // Atualizar os dados do formulário com o lote atual
          dadosForm.contas_ids = lote;

          // Enviar a requisição para o servidor como uma promessa
          console.log(`Enviando lote com ${lote.length} contas...`);
          await this.aplicarPerfilAsync(dadosForm, lote);
        }

        App.Util.ocultarModalPaginaCarregando();
        // Exibir mensagem de sucesso após todos os lotes serem processados
        swal.fire({
          icon: 'success',
          title: 'Perfil Aplicado!',
          text: 'O perfil foi aplicado às contas selecionadas. Atualize a página para visualizar as alterações.'
        });
      } catch (error) {
        App.Util.ocultarModalPaginaCarregando();
        // Tratar erros durante o processamento dos lotes
        console.error(`Erro ao processar lote:`, error);
        swal.fire({
          icon: 'error',
          title: 'Erro ao Aplicar Perfil',
          text: 'Ocorreu um erro ao processar um dos lotes. Verifique sua conexão e tente novamente.'
        });
      }
    }

    // Função para enviar um lote como uma promessa
    private aplicarPerfilAsync(dadosForm: any, lote: any[]): Promise<void> {
      return new Promise((resolve, reject) => {
        this.ajax.postAcao(this.urlAplicarPerfil, dadosForm, (resposta: { dadosEnviados: any, dadosRetornados: { dadosResposta: { perfil: { id: number, nome: string } } } }) => {
          console.log(`Lote com ${lote.length} contas processado com sucesso.`);
          resolve(); // Resolve a promessa quando a requisição for concluída
        }, null, true, false)
      });
    }

    private async aoAplicarFiltros(e: JQueryEventObject) {
      this.ajax = new App.Ajax();
      let dadosForm: any = this.ajax.convertFormToJSON($("#formAplicarFiltros"));

      // Obter os IDs das contas selecionadas
      const contasIds = this.modelViewContasVinculadas.getIdsContasSelecionadas();
      console.log("IDS", contasIds);

      // Dividir os IDs em lotes de 100
      const lotes = App.Util.chunkArray(contasIds, 100);
      $("#modalAplicarFiltros").modal('hide');

      try {
        // Processar os lotes de forma assíncrona, um por vez
        for (const lote of lotes) {
          // Atualizar os dados do formulário com o lote atual
          dadosForm.contas_ids = lote;

          // Enviar a requisição para o servidor como uma promessa
          console.log(`Enviando lote com ${lote.length} contas...`);
          await this.aplicarFiltrosAsync(dadosForm, lote);
        }

        // Exibir mensagem de sucesso após todos os lotes serem processados
        App.Util.ocultarModalPaginaCarregando();
        swal.fire({
          icon: 'success',
          title: 'Filtros Aplicados!',
          text: 'Os filtros foram aplicados às contas selecionadas. Atualize a página para visualizar as alterações.'
        });
      } catch (error) {
        App.Util.ocultarModalPaginaCarregando();
        // Tratar erros durante o processamento dos lotes
        console.error(`Erro ao processar lote:`, error);
        swal.fire({
          icon: 'error',
          title: 'Erro ao Aplicar Filtros',
          text: 'Ocorreu um erro ao processar um dos lotes. Verifique sua conexão e tente novamente.'
        });
      }
    }

    // Função para enviar um lote como uma promessa
    private aplicarFiltrosAsync(dadosForm: any, lote: any[]): Promise<void> {
      return new Promise((resolve, reject) => {
        this.ajax.postAcao(this.urlAplicarFiltro, dadosForm, (resposta: { dadosEnviados: any, dadosRetornados: { dadosResposta: { filtros: any[] } } }) => {
          console.log(`Lote com ${lote.length} contas processado com sucesso.`);
          resolve(); // Resolve a promessa quando a requisição for concluída
        }, null, true, false)
      });
    }

    private aoSelecionarTodosOsFiltros(e: JQueryEventObject) {
      try {
        var options = $('#filtro option');
        $('#filtro').val(options.map(function () { return this.value; }).get()).trigger('change');
      } catch (e) {
      }
    }

    private aoApagarTodosOsFiltros(e: JQueryEventObject) {
      try {
        $('#filtro').val("").trigger('change');
      } catch (e) {
      }
    }

    private inicializarEventosDataTables() {
      let aoSelecionarOuDeselecionar = (e: any, dt: any, type: any, indexes: any) => {
        if (type === 'row') {
          let contasSelecionadas = this.modelViewContasVinculadas.getContasSelecionadas()
          var count = contasSelecionadas.count();
          $('.btn-aplicar').html(count > 0 ? `+ Perfil (${count})` : `+ Perfil`)
          $('.btn-dt-aplicar-filtros').html(count > 0 ? `+ Filtros (${count})` : `+ Filtros`)
          $('.btn-ativar-selecionadas').html(count > 0 ? `Ativar (${count})` : `Ativar`)
          $('.btn-desativar-selecionadas').html(count > 0 ? `Desativar (${count})` : `Desativar`)
        }
      }

      this.modelViewContasVinculadas.ojDataTableCarregado.objDataTable.on('select', aoSelecionarOuDeselecionar);
      this.modelViewContasVinculadas.ojDataTableCarregado.objDataTable.on('deselect', aoSelecionarOuDeselecionar);

    }

    // Ativar/Desativar (agenda) de UMA conta pelo toggle da linha.
    private aoAtivarContaLinha(e: JQueryEventObject) {
      const input = $(e.currentTarget);
      const id = input.attr('data-id');
      const novoEstado = input.is(':checked');
      if (!this.ajax) { this.ajax = new App.Ajax(); }
      this.ajax.postAcao(this.urlAtivarContas, { contas_ids: [id], agenda_ativa: novoEstado }, () => {
        this.atualizarLinhaAgenda(id, novoEstado);
      }, null, false, false);
    }

    // Ativar/Desativar (agenda) das contas SELECIONADAS, em lotes de 100 (igual ao aplicar perfil/filtros).
    private async aoAtivarContasSelecionadas(ativar: boolean) {
      if (!this.ajax) { this.ajax = new App.Ajax(); }
      const contasIds = this.modelViewContasVinculadas.getIdsContasSelecionadas();
      if (!contasIds.length) {
        return;
      }

      const lotes = App.Util.chunkArray(contasIds, 100);
      try {
        for (const lote of lotes) {
          await this.ativarContasAsync(lote, ativar);
          lote.forEach((id: any) => this.atualizarLinhaAgenda(id, ativar));
        }
        // Linhas fora da página atual podem ter HTML em cache: invalida para serem remontadas
        // com os dados novos, sem precisar recarregar a página.
        this.modelViewContasVinculadas.ojDataTableCarregado.objDataTable.rows().invalidate().draw(false);
        App.Util.ocultarModalPaginaCarregando();
        swal.fire({
          icon: 'success',
          title: ativar ? 'Contas ativadas!' : 'Contas desativadas!',
          text: ativar
            ? 'As contas selecionadas foram ativadas.'
            : 'As contas selecionadas foram desativadas.'
        });
      } catch (error) {
        App.Util.ocultarModalPaginaCarregando();
        console.error('Erro ao ativar/desativar contas:', error);
        swal.fire({
          icon: 'error',
          title: 'Erro',
          text: 'Ocorreu um erro ao processar as contas. Verifique sua conexão e tente novamente.'
        });
      }
    }

    private ativarContasAsync(lote: any[], ativar: boolean): Promise<void> {
      return new Promise((resolve) => {
        this.ajax.postAcao(this.urlAtivarContas, { contas_ids: lote, agenda_ativa: ativar }, () => {
          resolve();
        }, null, true, false);
      });
    }

    // Atualiza o badge "Status Tarefa" e o toggle da linha após ativar/desativar (sem recarregar a página).
    private atualizarLinhaAgenda(idContaEa: any, ativa: boolean) {
      const dadosConta = this.dadosContasPorId[String(idContaEa)];
      if (dadosConta) {
        dadosConta.agendaAtiva = ativa;
      }

      const row = this.elTabelaContasvinculadas.find(`tr[id="${idContaEa}"]`);
      if (!row.length) {
        return;
      }

      const badge = ativa
        ? `<span class="badge badge-success text-uppercase cv-badge-on">Habilitada</span>`
        : `<span class="badge badge-danger text-uppercase cv-badge-off">Desabilitada</span>`;
      row.find('.js-status-tarefa-cell').html(badge);

      // Mantém o toggle da linha em sincronia (usado pelo toggle e pelas ações em lote).
      row.find('.js-toggle-ativar-conta').prop('checked', ativa);
    }
  }
}
